import { RespondentType } from '../../models/questions';
import { CheckoutState } from '../../state';
import { getEnablePaymentConstraintsInNewCreate } from '../app';
import {
    getIsFreeEvent,
    getIsReservedSeating,
    getSurveyType,
    hasSpecialInstructions,
    isWaitlistEnabled,
} from '../event';

export const areSyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) =>
    !getEnablePaymentConstraintsInNewCreate(state) &&
    !getIsFreeEvent(state) &&
    !getIsReservedSeating(state) &&
    !hasSpecialInstructions(state) &&
    !isWaitlistEnabled(state) &&
    (getSurveyType(state) === RespondentType.buyer ||
        getSurveyType(state) === RespondentType.direct);
